import React from "react"
import { TransactionItemProps } from "./props"

import {
  StyledLink,
  TransactionAmount,
  TransactionContainer,
  TransactionDescription,
  TransactionIcon,
  TransactionSource,
  TransactionTextContainer,
  TransactionTextsContainer,
  TransactionTime,
} from "./styled"

const TransactionItem = ({
  amount,
  time,
  source,
  description,
}: TransactionItemProps) => (
  <StyledLink to={`/history/${amount}`}>
    <TransactionContainer>
      <TransactionIcon />
      <TransactionTextsContainer>
        <TransactionTextContainer>
          <TransactionSource>{source}</TransactionSource>
          <TransactionAmount>{amount} ₽</TransactionAmount>
        </TransactionTextContainer>
        <TransactionTextContainer>
          <TransactionDescription>{description}</TransactionDescription>
          <TransactionTime>{time}</TransactionTime>
        </TransactionTextContainer>
      </TransactionTextsContainer>
    </TransactionContainer>
  </StyledLink>
)

export default TransactionItem
